import React from 'react';
import styled from 'styled-components';
import { Link } from 'gatsby';

import { SEO } from '../components/seo';

import { WrappedMenu } from '../components/new/Menu';
import { Footer } from '../components/new/Footer';

import { Container } from '../components/Container';
import { Wrap } from '../components/new/Wrap';
import { BaseHeadingStyle, H1 } from '../components/new/headers';
import { PageWrapper, ContentWrapper } from '../components/new/wrappers';
import { BaseListStyles, BaseTextStyle } from '../components/Styled';

export const H2 = styled(BaseHeadingStyle)`
    font-size: 48px;
    line-height: 100%;
    margin: 48px 0 16px;

    @media screen and (max-width: 760px) {
        font-size: 28px;
        margin-top: 32px;
    }
`;
const H3 = styled(BaseHeadingStyle)`
    font-size: 36px;
    line-height: 100%;
    margin: 32px 0 16px;
    display: inline-block;

    @media screen and (max-width: 760px) {
        font-size: 26px;
        margin-top: 32px;
    }
`;
// const HeadText = styled(BaseTextStyle)`
//     font-size: 24px;
//     display: inline-block;
//     line-height: 100%;
//     font-weight: 900;
//     margin: 0;
//     margin-top: 32px;
//     @media screen and (max-width: 760px) {
//         margin-top: 32px;
//     }
// `;

const Text = styled(BaseTextStyle)`
    margin: 0;

    & + & {
        margin-top: 32px;
    }
`;

const OrderedList = styled(BaseListStyles)`
    counter-reset: my-badass-counter;
    list-style: none;
    li::before {
        content: counters(my-badass-counter, '.') '. ';
        counter-increment: my-badass-counter;
    }
    &.leadList {
        > li::before {
            font-family: 'Futura PT', sans-serif;
            font-size: 36px;
            line-height: 100%;
        }
    }
`;
const UnorderedList = styled(BaseListStyles)`
    counter-reset: my-badass-counter;
    list-style: none;
    margin: 16px 8px 24px;

    li::before {
        content: '•';
        counter-increment: my-badass-counter;
        color: inherit;
        display: inline-block;
        width: 20px;
        margin-left: -20px;
        text-align: center;
    }
`;

const Table = styled.table`
    max-width: 100%;
    table-layout: fixed;
    border-collapse: collapse;
    text-align: left;
    margin: 48px 0 24px;
    border-bottom: 2px solid #000;

    tr:last-child {
        td {
            padding-bottom: 16px;
        }
    }

    th,
    td {
        font-family: 'Circe Web';
        font-size: 18px;
        line-height: 140%;

        @media screen and (max-width: 760px) {
            font-size: 16px;
            line-height: 140%;
        }
    }

    th {
        font-weight: 700;
        color: #000000;
        border-bottom: 2px solid;

        &:first-child {
            min-width: 192px;
            padding: 0 32px 0 0;
            box-sizing: border-box;

            @media screen and (max-width: 760px) {
                min-width: 80px;
                padding: 0 8px 0 0;
            }
        }
    }

    td {
        vertical-align: top;
        color: #404040;
        padding: 16px 32px 8px 0;
        box-sizing: border-box;

        a {
            color: #0b9cdb;

            &:hover {
                text-decoration: underline;
            }
        }

        @media screen and (max-width: 760px) {
            padding: 16px 8px 8px 0;
        }
    }
`;

const OfferPage = () => {
    // const isMobile = useIsMobile();
    return (
        <Wrap>
            <SEO title="Оферта" description="Оферта" />
            <Container>
                <WrappedMenu />
                <PageWrapper>
                    <H1 as="h1">Оферта</H1>
                    <H2 as="h2">
                        Договор публичной оферты об оказании
                        информационно-консультационных услуг
                    </H2>
                    <Text as="p">
                        <b>г. Москва, 03 сентября 2020г.</b>
                    </Text>
                    <ContentWrapper>
                        <Text as="p">
                            Общество с ограниченной ответственностью «Система
                            КЭСПА» (ОГРНИП: 1207700322488), именуемый в
                            дальнейшем Исполнитель (далее по тексту
                            «Исполнитель»), адресует настоящий Договор (далее
                            Договор) об оказании информационно-консультационных
                            услуг (далее – Услуги) по предоставлению доступа к
                            дистанционным занятиям по изучению английского языка
                            любым физическим лицом старше 18 (восемнадцати) лет,
                            выразившему готовность воспользоваться Услугами
                            Исполнителя (далее по тексту «Заказчик»).
                        </Text>
                        <H3 as="h3">ТЕРМИНЫ И ОПРЕДЕЛЕНИЯ</H3>
                        <Text as="p">
                            В настоящем Договоре, если иное прямо не вытекает из
                            текста, указанные ниже термины будут иметь следующие
                            значения:
                        </Text>
                        <Text as="p">
                            <b>Конфиденциальная информация</b> – информация,
                            которая включает в себя данные об аппаратной части и
                            программном обеспечении, экранах, технических
                            характеристиках, дизайнах, планах, чертежах, данных,
                            прототипах, открытиях, исследованиях, разработках,
                            методах, процессах, процедурах, методических
                            материалах, улучшениях, «ноу-хау», конфигурациях,
                            маркетинговых техниках, а также о планах,
                            техническую и коммерческую информацию, материалы в
                            устной, демонстрационной, письменной, графической
                            или машиночитаемой форме, которая не была
                            опубликована, и не является доступной для широкой
                            общественности и (или) торговли, и которая
                            поддерживается в качестве конфиденциальной и
                            служебной информации для раскрывающей стороны.
                        </Text>
                        <Text as="p">
                            <b>Платформа</b> – сайт в сети Интернет,
                            расположенный по сетевому адресу kespa.ru (далее по
                            тексту – «Сайт» и/или «Платформа») – представляет
                            собой программно-аппаратный комплекс Исполнителя,
                            содержащий совокупность информации, текстов,
                            графических элементов, дизайна, изображений, фото и
                            видеоматериалов (аудиовизуальных произведений) и
                            иных объектов интеллектуальной собственности, а
                            также программ для ЭВМ, содержащихся в
                            информационной системе, обеспечивающей доступность
                            такой информации в сети Интернет, товарный знак и
                            пр., которые принадлежат Исполнителю на правомерных
                            основаниях. Использование Заказчиком Сайта, его
                            содержимого и составляющих (как в целом, так и
                            фрагментарно) и прочих разработанных Исполнителем
                            программных решений не означает передачи Заказчику и
                            (или) любому третьему лицу прав на результаты
                            интеллектуальной деятельности, как в целом, так и в
                            части. Сайт является Интернет-ресурсом,
                            предназначенным для предоставления Заказчику доступа
                            к информационным материалам (содержимому Сайта) с
                            целью организации самообучения Заказчика английскому
                            языку на соответствующем уровне.
                        </Text>
                        <Text as="p">
                            <b>Материалы</b> – методическая программа и
                            материалы по изучению английского языка, права на
                            которые принадлежат Исполнителю (далее по тексту –
                            «материалы», включая видео лекции, видеоуроки, видео
                            консультации, практические занятия и тд.
                            (информационная библиотека); для доступа к
                            материалам от Заказчика может потребоваться
                            соблюдение специальных технических требований,
                            размещенных на Сайте.
                        </Text>
                        <Text as="p">
                            <b>Регистрация</b> – процесс регистрации на Сайте
                            подразумевает, что Заказчик заполняет форму,
                            оставляет свои данные, присваивает логин (имя
                            пользователя) и пароль, с помощью которых, сможет
                            заходить в свой личный кабинет на Сайте. Все
                            предоставленные Заказчиком при заключении Договора
                            сведения должны быть достоверными. Исполнитель, в
                            случае возникновения сомнений в достоверности
                            предоставленных Заказчиком данных, вправе в течение
                            всего срока оказания услуг запросить дополнительные
                            сведения и (или) потребовать подтверждения
                            предоставленных. Запрос направляется Заказчику по
                            электронной почте, указанной при регистрации.
                        </Text>
                        <Text as="p">
                            <b>Личный кабинет</b> (далее по тексту – «личный
                            кабинет») – защищенный подраздел Платформы,
                            созданный в результате регистрации Заказчика, в
                            качестве пользователя и содержащий информацию о нем,
                            включая, но не ограничиваясь такими, как личные и
                            контактные данные Заказчика, электронный почтовый
                            адрес, а также иные данные необходимые для
                            исполнения Договора. В Личном кабинете отображается
                            информация о начатых и завершенных Заказчиком этапах
                            самообучения, о Кураторах, о произведенных платежах
                            в счет оплаты доступа к Платформе и выбранным на ней
                            материалам, являющейся содержимым Платформы. В
                            Личном кабинете Заказчик имеет возможность
                            направлять сообщения представителям Исполнителя и
                            Кураторам. В Личном кабинете Заказчик может оплатить
                            доступ к Платформе и выбранным Занятиям и
                            материалам, согласно тарифам, установленным в
                            настоящем Договоре.
                        </Text>
                        <Text as="p">
                            <b>Тарифы</b> – стоимость предоставления доступа
                            (права использования) к Платформе и ее содержимому,
                            определяется на соответствующей странице Платформы
                            Исполнителя публикуемой на Сайте. Исполнитель вправе
                            устанавливать различные скидки от стоимости
                            предоставления доступа (права использования). На
                            момент выбора Заказчиком варианта оплаты стоимость
                            является окончательной и изменению не подлежит.
                        </Text>
                        <Text as="p">
                            <b>Куратор</b> (далее по тексту – «Куратор») – лицо,
                            в обязанности которого входит совершение от имени
                            Исполнителя действий, направленных на
                            консультирование Заказчика, включая предоставление
                            комментариев к практическим работам, выполненным
                            Заказчиком.
                        </Text>
                        <Text as="p">
                            <b>Занятия</b> (далее по тексту «Занятия») –
                            дистанционные занятия по изучению английского языка,
                            представляющие собой доступ к ресурсам и материалам
                            с помощью Платформы, объединенных единой темой и
                            обладающих общей структурой повествования и
                            комплексом практических работ, права на которые
                            принадлежат Исполнителю, включая консультации
                            Кураторов, выбранных Заказчиком при получении
                            доступа.
                        </Text>
                        <Text as="p">
                            Иные термины и определения, встречающиеся в тексте
                            Договора, толкуются Сторонами в соответствии с
                            законодательством Российской Федерации и
                            сложившимися в сети Интернет обычными правилами
                            толкования соответствующих терминов.
                        </Text>
                        <OrderedList as="ol" className="leadList">
                            <li>
                                <H3 as="h3">Акцепт оферты</H3>
                                <OrderedList as="ol">
                                    <li>
                                        Текст настоящего Договора является
                                        публичной офертой (в соответствии со
                                        статьей 435 и частью 2 статьи 437
                                        Гражданского кодекса РФ). Настоящий
                                        Договор вступает в силу с момента
                                        размещения на Сайте. Исполнитель вправе
                                        в любое время по своему усмотрению
                                        изменить условия Договора или отозвать
                                        ее в порядке, предусмотренном настоящим
                                        Договором.
                                        <Text as="p">
                                            В случае изменения Исполнителем
                                            условий Договора, изменения вступают
                                            в силу с момента публикации
                                            измененных условий Договора на
                                            Сайте, если иной срок не указан
                                            Исполнителем в соответствующем
                                            уведомлении об изменениях.{' '}
                                        </Text>
                                        <Text as="p">
                                            В соответствии с пунктом 3 статьи
                                            438 ГК РФ акцепт Договора равносилен
                                            заключению Договора на условиях,
                                            изложенных в настоящем Договоре.{' '}
                                        </Text>
                                        <Text as="p">
                                            Заказчик считается заключившим с
                                            Исполнителем Договор посредством
                                            полного и безоговорочного принятия
                                            условий настоящего Договора (акцепт)
                                            путем совершения в совокупности
                                            следующих действий:{' '}
                                        </Text>
                                        <UnorderedList as="ul">
                                            <li>
                                                ознакомления с условиями
                                                настоящего Договора,
                                                устанавливающего условия
                                                использования Платформы, путем
                                                нажатия кнопки «Я принимаю
                                                условия пользовательского
                                                соглашения и даю согласие на
                                                обработку моих персональных
                                                данных» при регистрации;
                                            </li>
                                            <li>
                                                выражение Заказчиком согласия с
                                                условиями Договора путем
                                                внесения оплаты в порядке,
                                                определенном в Договоре;
                                            </li>
                                            <li>
                                                совершения регистрации на
                                                Платформе: внесение достоверных
                                                и актуальных данных, уникальные
                                                логин (адрес электронной почты),
                                                имя и/или фамилию (в
                                                соответствии с документом,
                                                удостоверяющим личность) в
                                                регистрационную форму, а также
                                                пароля и проставления
                                                соответствующей отметки о
                                                принятии условий настоящего
                                                Договора и Политики
                                                Конфиденциальности;
                                            </li>
                                            <li>
                                                подтверждение адреса электронной
                                                почты путем перехода по ссылке,
                                                направленной на указанной при
                                                регистрации адрес электронной
                                                почты.
                                            </li>
                                        </UnorderedList>
                                    </li>
                                    <li>
                                        Акцепт Заказчиком настоящего Договора
                                        означает, что он полностью согласен со
                                        всеми положениями настоящего Договора.
                                    </li>
                                    <li>
                                        С момента акцепта Заказчиком настоящий
                                        Договор считается заключенным. В
                                        подтверждение заключения настоящего
                                        Договора и по ходу его исполнения
                                        Заказчику приходят информационные письма
                                        на электронную почту, указанную
                                        Заказчиком Исполнителю при регистрации.
                                    </li>
                                    <li>
                                        Отношения в области защиты прав
                                        потребителей регулируются Гражданским
                                        кодексом РФ, Законом «О защите прав
                                        потребителей» и принимаемыми в
                                        соответствии с ним иными федеральными
                                        законами и правовыми актами Российской
                                        Федерации.
                                    </li>
                                </OrderedList>
                            </li>
                            <li>
                                <H3 as="h3">Предмет договора</H3>
                                <OrderedList as="ol">
                                    <li>
                                        В соответствии с настоящим договором
                                        Исполнитель обязуется оказывать
                                        Заказчику информационно-консультационные
                                        услуги по предоставлению доступа к
                                        дистанционным занятиям по английскому
                                        языку, посредством Платформы и программ,
                                        позволяющих проводить видеоконференции,
                                        а Заказчик обязуется принимать эти
                                        услуги и оплачивать их в соответствии с
                                        условиями, предусмотренными настоящим
                                        Договором.
                                    </li>
                                    <li>
                                        Количество Занятий, проводимых в
                                        соответствии с настоящим Договором,
                                        определяется количеством оплаченных
                                        Заказчиком часов доступа к Платформе.
                                    </li>
                                    <li>
                                        Методику и формат Занятий определяет
                                        Исполнитель, учитывая пожелания
                                        Заказчика, высказанные перед
                                        осуществлением оплаты Услуг, а также в
                                        ходе получения доступа.
                                    </li>
                                    <li>
                                        Доступ Заказчика к Платформе
                                        предоставляется Исполнителем через
                                        веб-интерфейс, после прохождения
                                        соответствующей процедуры регистрации на
                                        Платформе и осуществления Заказчиком
                                        оплаты, в порядке, предусмотренном
                                        разделом 8 настоящего Договора.
                                    </li>
                                    <li>
                                        На Заказчика возложена обязанность
                                        обеспечить конфиденциальность и
                                        безопасность его логина и пароля,
                                        используемых им для доступа к Платформе
                                        и ее содержимому. В случае утраты, а
                                        также в случаях незаконного доступа к
                                        логину и паролю третьими лицами,
                                        Заказчик обязуется незамедлительно
                                        сообщить об этом Исполнителю, путем
                                        направления соответствующего письма на
                                        электронный почтовый адрес, указанный на
                                        Сайте. До момента отправки указанного
                                        извещения все действия считаются
                                        совершенными Заказчиком. Заказчик
                                        обязуется, ни при каких условиях не
                                        предоставлять третьим лицам свой логин и
                                        пароль, используемый для доступа к
                                        Платформе и ее содержимому.
                                    </li>
                                </OrderedList>
                            </li>
                            <li>
                                <H3 as="h3">Права и обязанности сторон</H3>
                                <OrderedList as="ol">
                                    <li>
                                        Исполнитель обязуется:
                                        <OrderedList as="ol">
                                            <li>
                                                В согласованные Сторонами сроки
                                                оказать Услуги Заказчику
                                                надлежащим образом в
                                                соответствии с условиями
                                                настоящего Договора.
                                            </li>
                                            <li>
                                                Не разглашать Конфиденциальную
                                                информацию и данные,
                                                предоставленные Заказчиком в
                                                связи с исполнением настоящего
                                                Договора, не раскрывать и не
                                                разглашать такие факты или такую
                                                информацию (кроме информации
                                                общедоступного характера)
                                                какой-либо третьей стороне без
                                                предварительного письменного
                                                соглашения Заказчика.
                                            </li>
                                        </OrderedList>
                                    </li>
                                    <li>
                                        Исполнитель вправе:
                                        <OrderedList as="ol">
                                            <li>
                                                Определять формы и методы
                                                организации учебного процесса.
                                            </li>
                                            <li>
                                                Пользоваться услугами любых
                                                Кураторов, в целях
                                                своевременного и качественного
                                                исполнения обязательств по
                                                Договору.
                                            </li>
                                            <li>
                                                Требовать от Заказчика
                                                своевременной оплаты стоимости
                                                Услуг в соответствии с условиями
                                                настоящего Договора.
                                            </li>
                                            <li>
                                                В течение всего периода
                                                предоставления доступа
                                                Исполнитель оставляет за собой
                                                право на замену Куратора и
                                                изменения расписаний Занятий.
                                            </li>
                                            <li>
                                                Исполнитель вправе по своей
                                                инициативе перенести одно или
                                                несколько Занятий на другой
                                                день, проинформировав при этом
                                                Заказчика не менее чем за один
                                                календарный день до даты начала
                                                переносимого Занятия.
                                            </li>
                                            <li>
                                                В течение нерабочих праздничных
                                                дней в соответствии с
                                                законодательством РФ,
                                                Исполнитель оставляет за собой
                                                право на перенос Занятий на
                                                следующие за праздниками рабочие
                                                дни.
                                            </li>
                                            <li>
                                                Вести аудио- или видеозапись
                                                Занятий с целью контроля
                                                качества процесса оказания
                                                Услуг.
                                            </li>
                                            <li>
                                                Приостанавливать работу
                                                Платформы с целью проведения
                                                технических работ,
                                                предварительно уведомив об этом
                                                Заказчика не позднее чем за 24
                                                часа до проведения
                                                соответствующих работ.
                                            </li>
                                            <li>
                                                Использовать контактные данные,
                                                указанные Заказчиком при
                                                регистрации, для отправки
                                                информационных и
                                                рекламно-информационных
                                                материалов, направленных с целью
                                                информирования Заказчика о
                                                деятельности Исполнителя и ходе
                                                исполнения Договора. При
                                                отсутствии письменного или
                                                устного отказа Заказчика в
                                                получении данных материалов,
                                                направленного в адрес
                                                Исполнителя, согласие на
                                                получение данного рода
                                                материалов считается
                                                подтвержденным.
                                            </li>
                                            <li>
                                                Отказать Заказчику в
                                                предоставлении и продлении Услуг
                                                без объяснения причин отказа.
                                            </li>
                                        </OrderedList>
                                    </li>
                                    <li>
                                        Заказчик обязуется:
                                        <OrderedList as="ol">
                                            <li>
                                                Предоставить Исполнителю все
                                                сведения и данные, необходимые
                                                для выполнения своих
                                                обязательств по настоящему
                                                Договору. В эти данные входят:
                                                <UnorderedList as="ul">
                                                    <li>
                                                        контактные данные,
                                                        запрашиваемые Платформой
                                                        при регистрации;
                                                    </li>
                                                    <li>
                                                        персональные данные,
                                                        запрашиваемые Куратором
                                                        при проведении Занятий.
                                                    </li>
                                                </UnorderedList>
                                            </li>
                                            <li>
                                                Производить оплату за
                                                предоставление доступа к
                                                Платформе в соответствии с
                                                настоящим Договором.
                                            </li>
                                            <li>
                                                Не разглашать Конфиденциальную
                                                информацию и иные данные,
                                                предоставленные Исполнителем в
                                                связи с исполнением настоящего
                                                Договора, не раскрывать и не
                                                разглашать такие факты или
                                                информацию (кроме информации
                                                общедоступного характера)
                                                какой-либо третьей стороне без
                                                предварительного письменного
                                                согласия Исполнителя.
                                            </li>
                                            <li>
                                                Не загружать или иным образом не
                                                доводить до всеобщего сведения
                                                материалы, являющиеся
                                                информационным наполнением
                                                (содержанием) Платформы, Занятий
                                                и прочие результаты
                                                интеллектуальной деятельности
                                                Исполнителя или иных
                                                лиц-правообладателей, при
                                                отсутствии явным образом
                                                выраженного письменного согласия
                                                правообладателя/Исполнителя.
                                            </li>
                                            <li>
                                                Самостоятельно отслеживать все
                                                изменения в условиях настоящего
                                                Договора путем ознакомления с их
                                                содержанием, расположенным на
                                                Сайте.
                                            </li>
                                        </OrderedList>
                                    </li>
                                    <li>
                                        Заказчик вправе:
                                        <OrderedList as="ol">
                                            <li>
                                                Требовать от Исполнителя
                                                выполнения его обязательств по
                                                настоящему Договору в срок и с
                                                надлежащим качеством. Занятие
                                                считается проведенным надлежащим
                                                образом, если в течение 1
                                                (одного) часа с момента его
                                                проведения Заказчик не сообщит
                                                Исполнителю о том, что оно не
                                                состоялось по вине Куратора или
                                                Исполнителя.
                                            </li>
                                            <li>
                                                Обращаться к Исполнителю по
                                                вопросам, касающимся процесса
                                                предоставления доступа, получать
                                                достоверную информацию об оценке
                                                своих знаний.
                                            </li>
                                            <li>
                                                Отправить Исполнителю запрос на
                                                замену Куратора, сообщив об этом
                                                Исполнителю за 72 часа до
                                                установленной даты следующего
                                                занятия и аргументировав свой
                                                запрос в письменной или устной
                                                форме.
                                            </li>
                                            <li>
                                                Отказаться от выполнения условий
                                                настоящего Договора в случае,
                                                если Исполнитель не приступил к
                                                исполнению обязательств по
                                                настоящему Договору.
                                            </li>
                                        </OrderedList>
                                    </li>
                                    <li>
                                        Заказчик заявляет и гарантирует, что:
                                        <OrderedList as="ol">
                                            <li>
                                                ознакомился и согласен с
                                                условиями настоящей оферты и
                                                тарифами, а также Политикой
                                                Конфиденциальности, размещенными
                                                на Платформе.
                                            </li>
                                            <li>
                                                согласен и не может ссылаться на
                                                невозможность исполнения своих
                                                обязательств по Договору
                                                надлежащим образом, или на
                                                невозможность получения услуг от
                                                Исполнителя, или отказываться от
                                                услуг Исполнителя на основании
                                                несогласия с условиями настоящей
                                                оферты, тарифами, и/или
                                                Политикой Конфиденциальности по
                                                причине их не оформления в
                                                письменном виде, скрепленном
                                                подписями и печатями Сторон.
                                            </li>
                                            <li>
                                                безоговорочно согласен и
                                                признает, что достаточным и
                                                правомерным подтверждением факта
                                                предоставления доступа
                                                Исполнителем, оказываемого
                                                посредством Платформы
                                                Исполнителя, являются
                                                статистические данные о
                                                получении Заказчиком доступа,
                                                формируемые программным
                                                обеспечением Платформы
                                                Исполнителя.
                                            </li>
                                            <li>
                                                подтверждает свое согласие с
                                                тем, что факт совершения
                                                перехода и (или) нажатия
                                                клавиши, а также ввода
                                                информации и пр. действия через
                                                предоставленные Исполнителем
                                                аутентификационные и иные
                                                разделы на Платформе, в том
                                                числе посредством Личного
                                                кабинета с использованием данных
                                                Заказчика, означает совершение
                                                Заказчиком конклюдентных
                                                действий по регистрации,
                                                авторизации и (или) ввода
                                                необходимых данных, согласованию
                                                наименования, содержания,
                                                стоимости и сроков оказания
                                                услуг, или иных действий,
                                                ассоциируемых с Заказчиком. Все
                                                действия, произведенные с
                                                использованием данных Заказчика
                                                и личного кабинета, являются
                                                действиями самого Заказчика, что
                                                является бесспорным
                                                доказательством волеизъявления
                                                Заказчика.
                                            </li>
                                        </OrderedList>
                                    </li>
                                </OrderedList>
                            </li>
                            <li>
                                <H3 as="h3">
                                    Перенос занятий и неявка на занятия
                                </H3>

                                <OrderedList as="ol">
                                    <li>
                                        Перенос или отмена Занятий Заказчиком
                                        могут быть осуществлены не позднее, чем
                                        за 8 (Восемь) часов до начала Занятия.
                                        Несоблюдение указанного срока
                                        приравнивается к неявке Заказчика на
                                        Занятие и оплачивается по полной
                                        стоимости. Количество возможных
                                        переносов и отмен Занятий зависит от
                                        интенсивности графика занятий Заказчика.
                                        Заказчик имеет право на:
                                    </li>
                                    <OrderedList as="ol">
                                        <li>
                                            перенос или отмену 1 (Одного)
                                            Занятия в месяц при графике занятий
                                            1 (Одно) Занятие в неделю;
                                        </li>
                                        <li>
                                            перенос или отмену 2 (Двух) Занятий
                                            в месяц при графике занятий 2 (Два)
                                            и 3 (Три) Занятия в неделю;
                                        </li>
                                        <li>
                                            перенос или отмену 4 (Четырех)
                                            Занятий в месяц при графике занятий
                                            4 (Четыре) и более Занятий в неделю.
                                        </li>
                                    </OrderedList>
                                    <li>
                                        Куратор имеет право переносить Занятия
                                        (в случае болезни и по другим
                                        уважительным причинам), предупредив об
                                        этом Заказчика не менее, чем за 24 часа
                                        до назначенного времени Занятия. Если
                                        Заказчик считает, что Куратор слишком
                                        часто переносит Занятия или
                                        несвоевременно предупреждает о
                                        переносах, он вправе обратиться к
                                        Исполнителю с требованием о замене
                                        Куратора.
                                    </li>
                                    <li>
                                        Если в установленное время Заказчик
                                        недоступен для звонка Куратора, Куратор
                                        повторяет попытки связаться со
                                        Заказчиком (не менее трех раз). При этом
                                        временем начала Занятия считается
                                        установленное в графике занятий время
                                        Занятия. Если в результате вышеназванных
                                        процедур связаться со Заказчиком не
                                        удается, Занятие считается проведенным и
                                        оплачивается по полной стоимости.
                                    </li>
                                    <li>
                                        Если в установленное время начала
                                        Занятий плюс 5 (Пять) минут Заказчик не
                                        получает звонка от Куратора, он обязан
                                        немедленно связаться с Исполнителем.
                                        Занятия, которые не состоялись по вине
                                        Куратора, переносятся в полном объеме на
                                        другое время.
                                    </li>
                                </OrderedList>
                            </li>
                            <li>
                                <H3 as="h3">Приостановка занятий</H3>
                                <OrderedList as="ol">
                                    <li>
                                        Заказчик может приостановить оказание
                                        Услуг путем направления Исполнителю
                                        устного или письменного запроса не
                                        позднее чем за 48 (сорок восемь) часов
                                        до даты предполагаемого последнего
                                        Занятия перед перерывом. При этом
                                        Заказчик должен сообщить Исполнителю
                                        точную дату и время предполагаемого
                                        последнего Занятия перед перерывом, а
                                        также ориентировочную дату первого
                                        Занятия после перерыва.
                                    </li>
                                    <li>
                                        Исполнитель вправе приостановить
                                        оказание услуг по собственной инициативе
                                        в дни новогодних, рождественских и
                                        майских праздников, предварительно
                                        предупредив об этом Заказчик путем
                                        направления сообщений по электронной
                                        почте или телефонного звонка.
                                    </li>
                                </OrderedList>
                            </li>
                            <li>
                                <H3 as="h3">Отказ от продолжения занятий</H3>
                                <OrderedList as="ol">
                                    <li>
                                        Если настоящий Договор расторгается по
                                        желанию Заказчика, он должен
                                        предоставить Исполнителю мотивированный
                                        отказ от услуг Исполнителя. В этом
                                        случае Исполнитель возвращает Заказчику
                                        денежные средства в размере, равном
                                        сумме не исполненных Исполнителем
                                        обязательств за удержанием 25% от
                                        исходной суммы, уплаченной Заказчиком по
                                        договору.
                                    </li>
                                    <li>
                                        В случае расторжения Договора срок
                                        возврата денежных средств составляет не
                                        более 30 (тридцать) календарных дней.
                                    </li>
                                    <li>
                                        Куратор Заказчика может быть заменен по
                                        инициативе Исполнителя, при наличии для
                                        этого уважительных причин (временная
                                        нетрудоспособность Куратора, другие
                                        обстоятельства), о чем Исполнитель
                                        сообщает Заказчику по указанным
                                        контактным данным. В случае, если
                                        Заказчик не захочет заниматься с другим
                                        Куратором, Заказчик вправе приостановить
                                        проведение Занятий в порядке,
                                        предусмотренном настоящим Договором.
                                    </li>
                                </OrderedList>
                            </li>
                            <li>
                                <H3 as="h3">Порядок направления сообщений</H3>
                                <OrderedList as="ol">
                                    <li>
                                        Исполнитель и Куратор могут использовать
                                        любые контактные данные Заказчика, из
                                        указанных при регистрации, для
                                        направления ему информационных
                                        сообщений, в том числе об отмене и
                                        переносе Занятий.
                                    </li>
                                    <li>
                                        Для связи с Исполнителем Заказчик должен
                                        использовать контактные данные
                                        Исполнителя, указанные на странице Сайта{' '}
                                        <Link to="/contacts">
                                            https://kespa.ru/contacts
                                        </Link>
                                        .
                                    </li>
                                    <li>
                                        Для связи со своим Куратором Заказчик
                                        должен использовать контактные данные
                                        Куратора, указанные в профиле Куратора
                                        на соответствующей странице Платформы.
                                    </li>
                                    <li>
                                        Сообщения по телефону принимаются в
                                        рабочие часы (по будням с 10:00 до 21:00
                                        по московскому времени). Отправленные в
                                        другое время сообщения о переносе
                                        Занятий считаются непринятыми.
                                    </li>
                                </OrderedList>
                            </li>
                            <li>
                                <H3 as="h3">
                                    Стоимость услуг и порядок расчетов
                                </H3>
                                <OrderedList as="ol">
                                    <li>
                                        Стоимость Услуг Исполнителя публикуются
                                        Исполнителем на Сайте.
                                    </li>
                                    <li>
                                        Исполнитель может в одностороннем
                                        порядке изменять стоимость Услуг путем
                                        размещения информации на Сайте
                                        Исполнителя. При этом стоимость уже
                                        оплаченных Заказчиком занятий не
                                        подлежит изменению.
                                    </li>
                                    <li>
                                        Исполнитель по устному соглашению с
                                        Заказчиком имеет право изменить
                                        стоимость Услуг в том случае, когда
                                        Заказчик в устной или письменной форме
                                        направил Исполнителю запрос на
                                        обеспечение специальных условий обучения
                                        (нетипичная частота, длительность или
                                        время занятий, прохождение обучения у
                                        определенного Куратора).
                                    </li>
                                    <li>
                                        Оплата Услуг осуществляется в порядке
                                        стопроцентной предоплаты. Оплата
                                        производится банковской картой через
                                        форму платежной системы в личном
                                        кабинете Заказчика на сайте Платформы.
                                    </li>
                                    <li>
                                        Если у Заказчика закончились оплаченные
                                        Занятия, для продолжения доступа к
                                        Платформе и заказу Занятий он обязан
                                        оплатить доступ к следующим Занятиям до
                                        момента начала предполагаемого Занятия.
                                    </li>
                                    <li>
                                        В случае наличия у Заказчика
                                        задолженности по оплате Занятий в
                                        количестве 1 (одного) Занятия и более,
                                        Исполнитель вправе прекратить оказание
                                        Услуг и потребовать Заказчика возместить
                                        денежные средства, равные размеру
                                        задолженности.
                                    </li>
                                    <li>
                                        Моментом оплаты считается поступление
                                        денежных средств на расчетный счет
                                        Исполнителя.
                                    </li>
                                    <li>
                                        Заказчик самостоятельно несет
                                        ответственность за правильность
                                        производимых им платежей.
                                    </li>
                                    <li>
                                        Заказчик самостоятельно оплачивает все
                                        услуги организаций связи, необходимые
                                        для получения им Услуг Исполнителя.
                                    </li>
                                </OrderedList>
                            </li>
                            <li>
                                <H3 as="h3">Системные требования</H3>
                                <OrderedList as="ol">
                                    <li>
                                        Исполнитель не отвечает за неоказание
                                        услуги в связи с отсутствием у Заказчик
                                        необходимого оборудования, программного
                                        обеспечения или технических проблем с
                                        Интернетом.
                                    </li>
                                    <li>
                                        Минимальные системные требования:
                                        <UnorderedList as="ul">
                                            <li>
                                                Оперативная память компьютера: 2
                                                Гб и выше, процессор: 1 ядерный
                                                процессор от 1.8 ГГц;
                                            </li>
                                            <li>
                                                Операционная система: Windows
                                                7/8/8.1/10, Mac OS X
                                                10.9/10.10/10.11, Ubuntu Linux
                                                14.04/16.04;
                                            </li>
                                            <li>
                                                Установленный браузер Google
                                                Chrome последней стабильной
                                                пользовательской версии с
                                                включённым автообновлением;
                                            </li>
                                            <li>
                                                Установленная программа Skype
                                                последней стабильной версии или
                                                другой программы, позволяющей
                                                проводить видеоконференции;
                                            </li>
                                            <li>
                                                Наличие видеокамеры с
                                                разрешением 1 Мп и выше;
                                            </li>
                                            <li>Наличие микрофона;</li>
                                            <li>
                                                Интернет соединение от 10
                                                Мбит/сек.
                                            </li>
                                        </UnorderedList>
                                    </li>
                                </OrderedList>
                            </li>
                            <li>
                                <H3 as="h3">Ответственность сторон</H3>
                                <OrderedList as="ol">
                                    <li>
                                        В случае неисполнения или ненадлежащего
                                        выполнения Исполнителем обязанностей по
                                        настоящему Договору Заказчик вправе
                                        предъявить Исполнителю требование о
                                        возврате уплаченных им денежных средств
                                        в размере, равном сумме не исполненных
                                        Исполнителем обязательств, за удержанием
                                        суммы комиссий перевода денежных
                                        средств.
                                    </li>
                                </OrderedList>
                            </li>
                            <li>
                                <H3 as="h3">Интеллектуальная собственность </H3>
                                <OrderedList as="ol">
                                    <li>
                                        Все права на результаты интеллектуальной
                                        деятельности (Платформа, содержимое
                                        Платформы, материалы и прочие программы
                                        для ЭВМ, разработанные Исполнителем)
                                        доступ к которым предоставляется
                                        по-настоящему Договору Заказчику,
                                        принадлежат Исполнителю и/или его
                                        аффилированным лицам и партнерам на
                                        законных основаниях и в полном объеме.
                                        Использование Заказчиком Платформы,
                                        материалов и прочих разработанных
                                        Исполнителем программных средств и (или)
                                        программных обеспечений не означает
                                        передачи исключительных прав и (или)
                                        прав собственности на указанные
                                        результаты интеллектуальной деятельности
                                        в каком-либо объеме (полностью или
                                        частично) Заказчику и (или) третьим
                                        лицам. Никакие права на любое содержимое
                                        Платформы, включая, помимо прочего,
                                        произведения, текстовые и графические
                                        материалы, программы для ЭВМ, товарные
                                        знаки не переходят к Заказчику в
                                        результате пользования Платформой и
                                        заключения Договора.
                                    </li>
                                    <li>
                                        За исключением использования в объемах и
                                        способами, прямо предусмотренными
                                        настоящим Договором, Заказчик не вправе
                                        использовать Платформу и материалы (его
                                        содержимое и (или) его части).{' '}
                                    </li>
                                    <li>
                                        В случае нарушения Заказчиком условий
                                        Договора на использование Платформы и ее
                                        содержимого, Заказчик утрачивает
                                        предоставленные Исполнителем права на
                                        использование Платформы и материалов
                                        Исполнителя, с момента нарушения
                                        Исполнитель вправе требовать возмещения
                                        убытков.
                                    </li>
                                </OrderedList>
                            </li>
                            <li>
                                <H3 as="h3">Прочие условия</H3>
                                <OrderedList as="ol">
                                    <li>
                                        Услуги, оказываемые в соответствии с
                                        настоящим Договором, являются
                                        информационно-консультационными. Все
                                        занятия проходят с использованием
                                        Платформы и программ, позволяющим
                                        проводить видеоконференции.
                                    </li>
                                    <li>
                                        За невыполнение или ненадлежащее
                                        выполнение обязательств по настоящему
                                        Договору Стороны несут ответственность в
                                        соответствии с условиями настоящего
                                        Договора и законодательством Российской
                                        Федерации.
                                    </li>
                                    <li>
                                        Стороны не несут ответственности за
                                        полное или частичное неисполнение ими
                                        своих обязательств по настоящему
                                        Договору, если такое неисполнение
                                        явилось следствием обстоятельств
                                        непреодолимой силы (форс-мажор).
                                        Надлежащим подтверждением наличия
                                        форс-мажорных обстоятельств и их
                                        продолжительности для Сторон является
                                        справка, выдаваемая уполномоченными
                                        органами.
                                    </li>
                                    <li>
                                        Все споры или разногласия, возникающие
                                        между Сторонами по настоящему Договору
                                        или в связи с ним, разрешаются путем
                                        переговоров между ними. Сторона, чье
                                        право нарушено, направляет другой
                                        Стороне письменную претензию
                                        (требование) посредством электронной
                                        связи. Если в течение 15 (Пятнадцати)
                                        календарных дней Сторона, направившая
                                        претензию, не получила ответ на нее, а
                                        также, если в течение 15 (Пятнадцати)
                                        календарных дней с момента получения
                                        первого ответа на претензию Стороны не
                                        пришли к каким-либо договоренностям, то
                                        Сторона, чье право нарушено, вправе для
                                        защиты своего права обратиться в суд в
                                        порядке, установленном законодательством
                                        РФ.
                                    </li>
                                    <li>
                                        В случае если одно или более положений
                                        настоящего Договора являются по
                                        какой-либо причине недействительными, не
                                        имеющими юридической силы, такая
                                        недействительность не оказывает влияния
                                        на действительность любого другого
                                        положения Договора, которые остаются в
                                        силе.
                                    </li>
                                    <li>
                                        В течение срока действия настоящего
                                        Договора, а также по истечении срока его
                                        действия Стороны обязуются не разглашать
                                        и не использовать в своих интересах,
                                        равно как и в интересах любых третьих
                                        лиц, любую конфиденциальную информацию,
                                        в том числе деловую, коммерческую,
                                        техническую и иную информацию, которая
                                        не может быть известна Сторонам из
                                        общедоступных источников, переданную
                                        одной Стороной другой Стороне и которая
                                        стала известной Сторонам в связи с
                                        заключением и исполнением настоящего
                                        Договора.
                                    </li>
                                    <li>
                                        Заказчик не вправе передавать свои права
                                        по Договору третьей Стороне без
                                        письменного согласия Исполнителя.
                                    </li>
                                    <li>
                                        Заказчик дает свое согласие Исполнителю
                                        на обработку персональных данных
                                        Заказчика, предоставленных при
                                        регистрации, а также предоставленных
                                        Заказчиком в Личном кабинете после
                                        регистрации, согласно Политике
                                        Конфиденциальности, расположенной на
                                        Платформе. Под персональными данными
                                        понимается любая информация, относящаяся
                                        к Заказчику как к субъекту персональных
                                        данных, в том числе: фамилия, имя,
                                        отчество, паспортные данные, дата и
                                        место рождения, адрес места жительства,
                                        контактные данные (номер домашнего,
                                        мобильного, рабочего телефонов, адрес
                                        электронной почты), а также иная
                                        общедоступная информация.
                                    </li>
                                    <li>
                                        Заказчик согласен с тем, что в рамках
                                        обработки персональных данных
                                        Исполнитель, вправе осуществлять сбор,
                                        запись, систематизацию, накопление,
                                        анализ, использование, извлечение,
                                        распространение, передачу Операторам и /
                                        или любым иным третьим лицам (включая,
                                        но не ограничиваясь: организациям
                                        владельцам-серверов; организациям,
                                        оказывающим услуги по осуществлению
                                        звонков, смс - рассылок, любых иных
                                        видов рассылок и уведомлений;
                                        организациям, оказывающим услуги по
                                        проведению различных опросов и
                                        исследований и пр.), получение,
                                        обработку, хранение, уточнение
                                        (обновление, изменение), обезличивание,
                                        блокирование, удаление, уничтожение его
                                        персональных данных путем ведения баз
                                        данных автоматизированным, механическим,
                                        ручным способами в целях:
                                        <UnorderedList as="ul">
                                            <li>
                                                ведения и актуализации
                                                клиентской базы;
                                            </li>
                                            <li>
                                                получения и исследования
                                                статистических данных о качестве
                                                оказываемых услуг;
                                            </li>
                                            <li>
                                                проведения маркетинговых
                                                программ;
                                            </li>
                                            <li>
                                                изучения конъюнктуры рынка
                                                услуг;
                                            </li>
                                            <li>
                                                информирования о предлагаемых
                                                Исполнителем услугах, проводимых
                                                бонусных мероприятий, акций и
                                                т.д.;
                                            </li>
                                            <li>
                                                рекламирования и иного любого
                                                продвижения услуг на рынке путем
                                                осуществления прямых контактов с
                                                Заказчиком и иными
                                                потребителями;
                                            </li>
                                            <li>
                                                технической поддержки при
                                                обработке информации,
                                                документации и персональных
                                                данных с использованием средств
                                                автоматизации и без такого
                                                использования.
                                            </li>
                                        </UnorderedList>
                                    </li>
                                    <li>
                                        Заказчик выражает согласие на получение
                                        рекламы и разрешает Исполнителю и
                                        Операторам осуществлять в его адрес
                                        смс-рассылки, а также иные виды рассылок
                                        и уведомлений, в том числе рекламного
                                        характера, с использованием любых
                                        средств связи.
                                    </li>
                                </OrderedList>
                            </li>
                        </OrderedList>
                        <Table>
                            <tbody>
                                <tr>
                                    <th colSpan="2">Реквизиты Исполнителя</th>
                                </tr>
                                <tr>
                                    <td>Юридический адрес организации</td>
                                    <td>
                                        115191, Россия, Москва, Холодильный
                                        переулок, 3, корпус 1, стр. 8, подъезд 2
                                    </td>
                                </tr>
                                <tr>
                                    <td>ИНН</td>
                                    <td>7726467800</td>
                                </tr>
                                <tr>
                                    <td>ОГРН</td>
                                    <td>1207700322488</td>
                                </tr>
                                <tr>
                                    <td>Банк</td>
                                    <td>АО &laquo;АЛЬФА-БАНК&raquo;</td>
                                </tr>
                                <tr>
                                    <td>Расчетный счет</td>
                                    <td>40702810702860010180</td>
                                </tr>
                                <tr>
                                    <td>Юридический адрес банка</td>
                                    <td>
                                        107078, г. Москва, ул. Каланчевская, д.
                                        27
                                    </td>
                                </tr>
                                <tr>
                                    <td>Корр.счет банка</td>
                                    <td>30101810200000000593</td>
                                </tr>
                                <tr>
                                    <td>БИК банка</td>
                                    <td>044525593</td>
                                </tr>
                            </tbody>
                        </Table>
                    </ContentWrapper>
                    <a href="/sbercredit">
                        Информация об оплате в кредит через Сбербанк
                    </a>
                </PageWrapper>
            </Container>
            <Footer />
        </Wrap>
    );
};

export default OfferPage;
